<a class="open-messeger-btn" (click)="this.chatIsOpen ? closeAssistant() : openAssistant()"><span class="new-messages" *ngIf="newMessagesCount &gt; 0">{{newMessagesCount}}</span>Assistant</a>


// WEBPACK FOOTER //
// ./src/components/assistant/assistant.pug